import React, { useCallback } from "react";
import { FormField, Pane, Textarea, TextInput } from "evergreen-ui";

const InfoInput = ({
  date,
  amount,
  due,
  number,
  description,
  onDataChange,
}) => {
  const handleInputChange = useCallback(
    ({ field }) =>
      (event) => {
        onDataChange({
          [field]: event.target.value,
        });
      },
    [onDataChange]
  );

  return (
    <Pane display="flex" flexWrap="wrap">
      <Pane display="flex" flex="1 1 auto" flexDirection="column">
        <FormField label="Invoice Date" labelFor="date" marginBottom={16}>
          <TextInput
            id="date"
            onChange={handleInputChange({ field: "date" })}
            value={date || ""}
            type="date"
          />
        </FormField>
        <FormField label="Due Date" labelFor="due" marginBottom={16}>
          <TextInput
            id="due"
            onChange={handleInputChange({ field: "due" })}
            value={due || ""}
            type="date"
          />
        </FormField>
      </Pane>
      <Pane display="flex" flex="1 1 auto" flexDirection="column">
        <FormField label="Amount ($)" labelFor="amount" marginBottom={16}>
          <TextInput
            id="amount"
            onChange={handleInputChange({ field: "amount" })}
            value={amount || ""}
          />
        </FormField>
        <FormField label="Invoice Number" labelFor="number" marginBottom={16}>
          <TextInput
            id="number"
            onChange={handleInputChange({ field: "number" })}
            value={number || ""}
            type="text"
          />
        </FormField>
      </Pane>
      <Pane flex="1 1 100%">
        <FormField label="Description" labelFor="description">
          <Textarea
            id="description"
            onChange={handleInputChange({ field: "description" })}
            placeholder="(Optional) Is there anything else you want to add?"
            value={description || ""}
            maxLength="150"
            type="text"
          />
        </FormField>
      </Pane>
    </Pane>
  );
};

export default InfoInput;
